import styled from 'styled-components';

export const StyledEnvironmentInfo = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--color-text-main);
  width: 350px;
  box-shadow: 0px 0px 6px 0px #00000026;
  border-radius: 5px 5px 10px 10px;
  background-color: #ffffff;

  .component-title {
    font-size: 16px;
    font-weight: 600;
    color: #2f2f35;
    margin-bottom: 5px;
    padding: 15px 15px 0 15px;
  }

  .component-body {
    display: flex;
    flex-direction: row;
    gap: 10px;
    padding: 0 15px 15px 15px;
  }

  .left-area {
    flex: 1 0;
  }

  .left-area .weather {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 500;
    color: #585959;
    gap: 10px;
  }

  .right-area {
    flex: 1 0;
  }

  .right-area .date-time {
    display: flex;
    flex-direction: column;
    height: 36px;
  }

  .right-area .date {
    font-size: 12px;
    font-weight: 600;
    text-wrap: nowrap;
    color: #585959;
  }

  .right-area .time {
    font-size: 10px;
    font-weight: 400;
    color: #2f2f35;
  }

  .item {
    display: flex;
    margin-top: 7px;
  }

  .item .label {
    font-size: 12px;
    font-weight: 500;
    color: #2f2f35;
    width: 70px;
  }

  .item .value {
    font-size: 12px;
    font-weight: 400;
    color: #585959;
    display: flex;
    align-items: center;
  }

  .item .value.point .main-value {
    font-size: 12px;
    font-weight: 400;
  }

  .item .value.point .sub-value {
    font-size: 8px;
    font-weight: 400;
    margin-bottom: 1px;
    letter-spacing: -0.3px;
  }

  .item .value.purple .main-value,
  .item .value.purple .sub-value {
    color: #660099 !important;
  }

  .item .value.red .main-value,
  .item .value.red .sub-value {
    color: #7e0023 !important;
  }

  .bottom-line {
    padding-bottom: 7px;
    border-bottom: 1px solid #dadada;
  }

  .lightning-sensor-wrap {
    border-radius: 0 0 10px 10px;
    border-left: 3px solid;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .ls-icon {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  .ls-icon-img {
    display: inline-block;
    width: 12px;
    height: 18px;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: contain;
    mask-size: contain;
    -webkit-mask-position: center;
    mask-position: center;
  }

  .ls-content {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  .ls-title {
    font-size: 11px;
    font-weight: 600;
    color: #222222;
  }

  .ls-details {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    font-weight: 400;
    color: #222222;
  }

  .ls-details .detail-value-highlight {
    font-weight: 500;
    font-size: 11px;
    padding-left: 2px;
  }

  .ls-details .sep {
    color: #dadada;
  }

  .ls-details .detail-label {
    font-size: 11px;
    font-weight: 400;
    color: #222222;
    padding-right: 5px;
  }

  .ls-details .detail-value {
    font-size: 11px;
    font-weight: 500;
    color: #222222;
  }

  /* Emergency */
  .lightning-sensor-wrap.ls-emergency {
    background-color: #fc1e0f14;
    border-left-color: #fc1e0f;
  }
  .lightning-sensor-wrap.ls-emergency .ls-status-text,
  .lightning-sensor-wrap.ls-emergency .detail-value-highlight {
    color: #fc1e0f;
  }
  .lightning-sensor-wrap.ls-emergency .ls-icon-img {
    background-color: #fc1e0f;
  }

  /* Danger */
  .lightning-sensor-wrap.ls-danger {
    background-color: #ff8f3114;
    border-left-color: #ff8f31;
  }
  .lightning-sensor-wrap.ls-danger .ls-status-text,
  .lightning-sensor-wrap.ls-danger .detail-value-highlight {
    color: #ff8f31;
  }
  .lightning-sensor-wrap.ls-danger .ls-icon-img {
    background-color: #ff8f31;
  }

  /* Warning */
  .lightning-sensor-wrap.ls-warning {
    background-color: #ffcb301a;
    border-left-color: #ffcb30;
  }
  .lightning-sensor-wrap.ls-warning .ls-status-text,
  .lightning-sensor-wrap.ls-warning .detail-value-highlight {
    color: #ffcb30;
  }
  .lightning-sensor-wrap.ls-warning .ls-icon-img {
    background-color: #ffcb30;
  }

  /* Caution */
  .lightning-sensor-wrap.ls-caution {
    background-color: #60b0f21a;
    border-left-color: #60b0f2;
  }
  .lightning-sensor-wrap.ls-caution .ls-status-text,
  .lightning-sensor-wrap.ls-caution .detail-value-highlight {
    color: #60b0f2;
  }
  .lightning-sensor-wrap.ls-caution .ls-icon-img {
    background-color: #60b0f2;
  }

  /* Normal */
  .lightning-sensor-wrap.ls-normal {
    background-color: #67d0871a;
    border-left-color: #67d087;
  }
  .lightning-sensor-wrap.ls-normal .ls-status-text,
  .lightning-sensor-wrap.ls-normal .detail-value-highlight {
    color: #67d087;
  }
  .lightning-sensor-wrap.ls-normal .ls-icon-img {
    background-color: #67d087;
  }
`;
